import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.recommendation')
  .factory('$recommendation', recommendationObjectFactory);

function recommendationObjectFactory($bringozFactory: $bringozFactory,
                                     RecommendationAPI: BringozApi,
                                     Recommendation_DS: DataStoreConfig) {

  function $recommendation(id: string) {
    return $bringozFactory(id, RecommendationAPI, Recommendation_DS)
  }

  return $recommendation
}

